import { createAsyncThunk } from '@reduxjs/toolkit'
import { serializableError } from '@utils/serializable_error.ts'
import CustomizationWebAPI from '@api/CustomizationWebAPI.js'
import { handleSaveOptionsSuccess } from './ServerActions.js'

export const saveOptions = createAsyncThunk('viewOptions/saveOptions', async (object, thunkAPI) => {
  const { viewId, options } = object
  const { dispatch, rejectWithValue } = thunkAPI
  try {
    const response = await CustomizationWebAPI.saveViewCustomization(viewId, options)
    dispatch(handleSaveOptionsSuccess(response))
    // Note: Anything returned here becomes the payload of fulfilled action
  } catch (error) {
    return rejectWithValue(serializableError(error))
  }
})
